import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { binderApi } from 'services/apis';
import { ReplaceBinderPayloadDto } from 'libs/pinnacle-sdk';
import { BinderForm } from '../new-binder-form';
import { EQueryKeys } from 'constants/query-keys';
import { useParams } from 'react-router';
import dayjs from 'dayjs';
import { getLocalDateForMidnightUTC } from 'utils';

const UpdateBinderForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const { data: binder, isLoading: isFetchingBinder } = useQuery(
    [EQueryKeys.BINDER_BY_ID, id],
    () => binderApi.getBinderById({ binderId: id as string }),
    {
      enabled: !!id,
    }
  );

  const updateBinderMutation = useMutation<
    void,
    Error,
    { binder: ReplaceBinderPayloadDto; fileIds: string[] }
  >(async ({ binder, fileIds }) => {
    await binderApi.replaceBinder({
      binderId: id as string,
      replaceBinderPayloadDto: {
        ...binder,
        fileIds,
      },
    });
    queryClient.invalidateQueries([EQueryKeys.BINDER_BY_ID, id]);
  });

  return (
    <BinderForm
      mode="update"
      initialData={
        binder
          ? {
              ...binder,
              authorityEndDate: getLocalDateForMidnightUTC(
                binder.authorityEndDate
              ),
              authorityStartDate: getLocalDateForMidnightUTC(
                binder.authorityStartDate
              ),
            }
          : undefined
      }
      files={binder?.files}
      onSubmit={updateBinderMutation.mutateAsync}
      isLoading={isFetchingBinder || updateBinderMutation.isLoading}
    />
  );
};

export default UpdateBinderForm;
